var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProp65Warning = function SvgProp65Warning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.539 507.943"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.39 494.183h512.191a18.52 18.52 0 0 0 16.043-9.265 18.51 18.51 0 0 0 0-18.524L303.529 22.822a18.526 18.526 0 0 0-32.086 0L15.346 466.394a18.527 18.527 0 0 0 16.044 27.789"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "m287.485 69.346 223.827 387.679H63.658z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.485,
    cy: 399.078,
    r: 25.644
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m303.068 344.582 18.396-167.807a34.37 34.37 0 0 0-17.297-33.69 34.37 34.37 0 0 0-50.164 38.455l19.122 166.535a15.074 15.074 0 1 0 29.943-3.493"
  })));
};
export default SvgProp65Warning;